module.exports = __webpack_public_path__ + "img/shape-ornament-02.38f012b4.png";